<template>
  <JbStandardNew
    :biz-ctg="$config.BIZ_CATEGORY.ELEVATOR"
    @link="handleLink"
  ></JbStandardNew>
</template>

<script>
import JbStandardNew from '@/views/omp/cleaning/standard/components/JbStandardNew.vue'
export default {
  name: 'ElevatorStandardNew',
  components: {
    JbStandardNew
  },
  computed: {},
  data() {
    return {}
  },
  created() {},
  methods: {
    handleLink() {
      this.$tabs.close({ to: '/omp/elevator/standard/list' })
    }
  }
}
</script>

<style lang="scss" scoped></style>
